import { render, staticRenderFns } from "./VehicleRequestCompare.vue?vue&type=template&id=e327e1a2&"
import script from "./VehicleRequestCompare.vue?vue&type=script&lang=js&"
export * from "./VehicleRequestCompare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports